import ContactForm from '@/components/contact-form'
import { MetaTags } from '@/components/meta-tags'
import { usePage } from '@inertiajs/react'

export default function Contact() {
  const {
    title,
    og_title,
    og_type,
    og_url,
    og_image,
    og_description,
    twitter_title,
    twitter_url,
    twitter_image,
    twitter_description,
  } = usePage().props
  return (
    <>
      <MetaTags
        title={title}
        description={og_description}
        og_title={og_title}
        og_type={og_type}
        og_url={og_url}
        og_image={og_image}
        og_description={og_description}
        twitter_title={twitter_title}
        twitter_url={twitter_url}
        twitter_image={twitter_image}
        twitter_description={twitter_description}
      />
      <div className="flex w-full flex-col items-center justify-start">
        <div className="container flex max-w-4xl flex-col items-center justify-start p-4 pt-[120px]">
          <article className="article-prose w-full">
            <h1>Contact Us</h1>
            <p className="text-balance">
              Have a question or running into an issue? We're here to help! Your
              feedback helps improve picchat.ai for you and everyone else.
            </p>
            <br />
            <ContactForm />
          </article>
        </div>
      </div>
    </>
  )
}
